<form [formGroup]="projectForm" (ngSubmit)="onSubmit()" class="space-y-6 w-1/2 mx-auto">
    <div class="flex-1 flex flex-col gap-2">
        <label for="name" class="font-medium">Nom du projet</label>
        <input id="name" formControlName="name" type="text" pInputText class="p-2 border rounded text-[16px]" />
        <span *ngIf="projectForm.get('name')?.invalid && projectForm.get('name')?.touched" class="text-red-500 text-sm">
            Nom du projet obligatoire
        </span>
    </div>
    <div class="flex-1 flex flex-col gap-2">
        <label for="description" class="font-medium">Description du projet</label>
        <textarea id="description" formControlName="description" rows="4" pInputText
            class="p-2 border rounded w-full "></textarea>
        <span *ngIf="projectForm.get('description')?.invalid && projectForm.get('description')?.touched"
            class="text-red-500 text-sm">
            Description obligatoire
        </span>
    </div>
    <div class="text-center mt-6">
        <p-button type="submit" label="{{ isEditMode ? 'Mettre à jour' : 'Ajouter un projet' }}"
           [disabled]="projectForm.invalid">
        </p-button>
    </div>
</form>